"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _formContext = require("./formContext");
Object.keys(_formContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _formContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formContext[key];
    }
  });
});
var _ratingAndReviewDialogContext = require("./ratingAndReviewDialogContext");
Object.keys(_ratingAndReviewDialogContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ratingAndReviewDialogContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ratingAndReviewDialogContext[key];
    }
  });
});
var _resultContext = require("./resultContext");
Object.keys(_resultContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _resultContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _resultContext[key];
    }
  });
});
